var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "ml-4 align-center" },
    [
      _c(
        "v-btn",
        {
          attrs: { icon: "" },
          on: {
            click: function ($event) {
              return _vm.$router.push({ name: "problemsList" })
            },
          },
        },
        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "pr-2",
                          attrs: { color: "primary", depressed: "", light: "" },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(" " + _vm._s(_vm.problemName) + " "),
                      _c("v-icon", [_vm._v("mdi-chevron-down")]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                {
                  on: {
                    click: function ($event) {
                      _vm.renameShow = true
                    },
                  },
                },
                [_c("v-list-item-title", [_vm._v("Переименовать")])],
                1
              ),
              _c(
                "v-list-item",
                [_c("v-list-item-title", [_vm._v("Удалить")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-btn",
        { attrs: { icon: "" }, on: { click: _vm.logout } },
        [_c("v-icon", [_vm._v("mdi-logout")])],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "50%" },
          on: {
            close: function ($event) {
              _vm.renameShow = false
            },
          },
          model: {
            value: _vm.renameShow,
            callback: function ($$v) {
              _vm.renameShow = $$v
            },
            expression: "renameShow",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: { label: "Название модели" },
                    model: {
                      value: _vm.newName,
                      callback: function ($$v) {
                        _vm.newName = $$v
                      },
                      expression: "newName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { large: "", color: "primary" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Сохранить")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }